<template lang="pug">
  .table-responsive
    table#tbResponsivas.table.is-striped.is-fullwidth.is-narrow(v-show="hayDatos")
      thead
        tr
          th.is-size-6
            | #
          th.is-size-6 
            | Usuario
          th.is-size-6 
            | Responsivas
      tbody
        tr(v-for="(resp, index) in responsivas" :key="resp.id")
          td 
            a.button.is-black.is-small.is-rounded
              | {{ index + 1 }}
          td {{ resp.usuario }}
          td
            div.tags
              span.tag(v-for="r in resp.responsivas" :key="r.id" :class="r.firma_gerente === '' || r.firma_user === '' ? 'is-warning' : 'is-success'" @click="verModal(r)")
                span(v-html="getDataResp(r)")
    .notification(v-show="!hayDatos")
      strong  No registros aún.
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'TbResponsivas',
    props: {
      responsivas: {
        type: Array,
        default: []
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        hayDatos: false,
        isDisabled: this.disabled
      }
    },
    watch: {
      responsivas() {
        this.checkDatos()  
      }
    },
    methods: {
      iniciarComponente () {
        if (this.userLogin.cargo === '002') {
            this.isDisabled = false
        }
        this.checkDatos()
      },
      checkDatos () {
        if (this.responsivas.length > 0) {
          this.hayDatos = true
        } else {
          this.hayDatos = false
        }
      },
      getCategoria (cat) {
        let respHtml = ''
        switch (cat) {
          case 0:
            respHtml = `is-dark`
            break
          case 1:
            respHtml = `is-black`
            break
          case 2:
            respHtml = `is-info`
            break
          case 3:
            respHtml = `is-danger`
            break
          case 4:
            respHtml = `is-warning`
            break
          case 5:
            respHtml = `is-link`
            break
        
          default:
            respHtml = ``
            break
        }

        return respHtml
      },
      getDataResp (data) {
        let htmlRes = ''
        switch (data.categoria) {
          case 0:
            htmlRes = `<i class="fas fa-shapes"></i>`
            break
          case 1:
            htmlRes = `<i class="fas fa-laptop"></i>`
            break
          case 2:
            htmlRes = `<i class="fas fa-mobile-alt"></i>`
            break
          case 3:
            htmlRes = `<i class="fas fa-gas-pump"></i>`
            break
          case 4:
            htmlRes = `<i class="fas fa-ticket-alt"></i>`
            break
          case 5:
            htmlRes = `<i class="fas fa-car"></i>`
            break
          default:
            htmlRes = ``
            break
        }
        return htmlRes
      },
      
      getEstado (resp) {
        let htmlres = ''
        switch (resp.estado) {
          case 1:
            htmlres = `<a class="button is-rounded is-small">Firmar Entrega</a>`
            break
          case 2:
            htmlres = `<a class="button is-rounded is-black is-small">Firmado Entrega</a>&nbsp<a class="button is-rounded is-small">Firmar Recibe</a>`
            break
          case 3:
            htmlres = `<a class="button is-info is-rounded is-small">Firmado Recibe</a>`
            break
        
          default:
            htmlres = `<a class="button is-success is-rounded is-small">Sin Firma</a>`
            break
        }
        return htmlres
      },
      getEstadoFirmas (resp) {
        if (resp.firma_gerente === '' && resp.firma_user) {
          return false
        } else {
          return true
        }
      },
      verModal (responsiva) {
        this.$emit('verModal', responsiva)
      }
    },
    created () {
      this.iniciarComponente()
    },
    computed: {
      ...mapState(['logueado', 'userLogin', 'permisos'])
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/responsivas_Componentes/components/TbResponsivas.vue